var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "GamePane",
    {
      attrs: { product: "tai-xiu", wide: _vm.wide },
      scopedSlots: _vm._u(
        [
          {
            key: "title",
            fn: function () {
              return [
                _vm.table
                  ? _c("div", { staticClass: "tai-xiu-pane__identity" }, [
                      _c("strong", [_vm._v(_vm._s(_vm.table.code))]),
                      _vm.table.name
                        ? _c("span", { staticClass: "tai-xiu-pane__name" }, [
                            _vm._v("· " + _vm._s(_vm.table.name)),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "video",
            fn: function () {
              return [
                _c("TaiXiuFullVideo", { attrs: { "arena-id": _vm.arenaId } }),
              ]
            },
            proxy: true,
          },
          _vm.table
            ? {
                key: "info",
                fn: function () {
                  return [
                    _c("TaiXiuBoardHeader", {
                      attrs: {
                        table: _vm.table,
                        "is-rolling": _vm.isRolling,
                        "float-result": "",
                      },
                    }),
                  ]
                },
                proxy: true,
              }
            : null,
          _vm.wide && _vm.table
            ? {
                key: "aside",
                fn: function () {
                  return [
                    _c("BetHistoryCharts", {
                      staticClass: "tai-xiu-pane__roads",
                      attrs: {
                        "recent-results": _vm.table.recentResults,
                        "recent-dice": _vm.table.recentDice,
                        "recent-rounds": _vm.table.recentRounds,
                        code: _vm.table.code,
                      },
                    }),
                  ]
                },
                proxy: true,
              }
            : null,
          !_vm.wide
            ? {
                key: "selector",
                fn: function () {
                  return [
                    _c("ArenaChips", {
                      attrs: { items: _vm.arenaItems },
                      on: {
                        select: function ($event) {
                          return _vm.$emit("select-arena", $event)
                        },
                      },
                    }),
                  ]
                },
                proxy: true,
              }
            : null,
        ],
        null,
        true
      ),
    },
    [
      _vm.table
        ? _c(
            "BetBoard",
            _vm._g(
              _vm._b(
                {
                  staticClass: "tai-xiu-pane__board",
                  class: { "tai-xiu-pane__board--wide": _vm.wide },
                  attrs: { full: "", "hide-charts": _vm.wide },
                  scopedSlots: _vm._u(
                    [
                      _vm.wide
                        ? {
                            key: "under-board",
                            fn: function () {
                              return [
                                _c("ArenaChips", {
                                  staticClass: "tai-xiu-pane__rail",
                                  attrs: { items: _vm.arenaItems },
                                  on: {
                                    select: function ($event) {
                                      return _vm.$emit("select-arena", $event)
                                    },
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          }
                        : null,
                    ],
                    null,
                    true
                  ),
                },
                "BetBoard",
                _vm.boardProps,
                false
              ),
              _vm.boardListeners
            )
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }